var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyEur = function SvgIconCurrencyEur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.871 4.862a5.75 5.75 0 0 0-6.704 4.263h5.583a1 1 0 1 1 0 2H7v1.75h4.25a1 1 0 1 1 0 2H7.167a5.75 5.75 0 0 0 9.648 2.69 1 1 0 1 1 1.414 1.414 7.75 7.75 0 0 1-13.106-4.104H3.75a1 1 0 1 1 0-2H5v-1.75H3.75a1 1 0 1 1 0-2h1.373A7.75 7.75 0 0 1 18.23 5.021a1 1 0 1 1-1.414 1.414 5.75 5.75 0 0 0-2.944-1.573"
  })));
};
export default SvgIconCurrencyEur;